import cx from "classnames";

// CSS
import styles from "./button.module.scss";

const Button = (props) => {
    const { classes, onClick, size, style, text, theme } = props;

    return (
        <button
            className={cx(styles.button, classes, {
                [styles[`button--${size}`]]: size,
                [styles[`button--${theme}`]]: theme,
            })}
            onClick={onClick}
            style={style}
        >
            {text}
        </button>
    );
};

export default Button;
